export const CELLYTICS_DEFAULT_ANALYSIS_SET = "260604";
export const CELLYTICS_DEFAULT_ANALYSIS_PATH = "/260604/dashboard";

const DATE_ICON = "M6.75 3v2.25M17.25 3v2.25M3.75 8.25h16.5M4.5 6.75A2.25 2.25 0 0 1 6.75 4.5h10.5a2.25 2.25 0 0 1 2.25 2.25v10.5a2.25 2.25 0 0 1-2.25 2.25H6.75a2.25 2.25 0 0 1-2.25-2.25V6.75Z";
const DASHBOARD_ICON = "M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 0 1 3 19.875v-6.75ZM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V8.625ZM16.5 4.125C16.5 3.504 17.004 3 17.625 3h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V4.125Z";
const REPORT_ICON = "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5A3.375 3.375 0 0 0 10.125 2.25H8.25m0 12.75h7.5m-7.5 3h7.5M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-1.125 1.125-1.125V11.25a9 9 0 0 0-9-9Z";
const BACKGROUND_ICON = "M12 3v2.25m0 13.5V21m8.25-9H18M6 12H3.75m14.91-6.36-1.59 1.59M6.93 17.07l-1.59 1.59m13.32 0-1.59-1.59M6.93 6.93 5.34 5.34M15.75 12a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z";
const BLUR_ICON = "M3.75 6.75h16.5M3.75 12h16.5M3.75 17.25h16.5";
const FILTER_ICON = "M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 0 1-.659 1.591l-5.432 5.432a2.25 2.25 0 0 0-.659 1.591v2.927a2.25 2.25 0 0 1-1.244 2.013l-2.25 1.125A1.125 1.125 0 0 1 9 19.491v-5.059a2.25 2.25 0 0 0-.659-1.591L2.909 7.409A2.25 2.25 0 0 1 2.25 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0 1 12 3Z";
const I3_ICON = "M3 16.5h18M6 20.25V9.75m6 10.5V3.75m6 16.5v-7.5";
const THRESHOLD_ICON = "M4.5 6.75h9.75M4.5 12h15M4.5 17.25h6.75m4.5-10.5a2.25 2.25 0 1 0 4.5 0 2.25 2.25 0 0 0-4.5 0Zm-9 10.5a2.25 2.25 0 1 0 4.5 0 2.25 2.25 0 0 0-4.5 0Z";
const RAW_ANALYSIS_ICON = "M3.75 5.25h16.5M3.75 9.75h16.5M6 14.25h3.75M6 18.75h3.75m4.5-4.5h3.75m-3.75 4.5h3.75";

export const CELLYTICS_ANALYSIS_PAGES = [
    { id: "dashboard", label: "요약/상관", path: "dashboard", icon: DASHBOARD_ICON },
    { id: "i3", label: "I3 비교", path: "i3", icon: I3_ICON, requiresI3: true },
    { id: "report", label: "보고서", path: "report", icon: REPORT_ICON, requiresReport: true },
    { id: "analysis", label: "원본 재분석", path: "analysis", icon: RAW_ANALYSIS_ICON, requiresRawAnalysis: true },
    { id: "background", label: "밝기 보정", path: "background", icon: BACKGROUND_ICON, requiresBackground: true },
    { id: "blur", label: "Blur 비교", path: "blur", icon: BLUR_ICON },
    { id: "filtering", label: "MMD filtering", path: "filtering", icon: FILTER_ICON },
    { id: "threshold", label: "Threshold 분석", path: "threshold", icon: THRESHOLD_ICON, requiresThreshold: true },
];

export const CELLYTICS_ANALYSIS_SETS = [
    {
        id: "260604",
        label: "260604",
        dataUrl: "/assets/cellytics/analysis-data.json",
        defaultPage: "dashboard",
        backgroundAvailable: true,
        reportAvailable: true,
        i3Available: false,
        recommendedCaseId: "background_blur_mmd_filter",
    },
    {
        id: "260622",
        label: "260622",
        dataUrl: "/assets/cellytics/260619/analysis-data.json?v=260625-filtered-scale",
        defaultPage: "report",
        backgroundAvailable: false,
        reportAvailable: true,
        thresholdAvailable: true,
        rawAnalysisAvailable: true,
        i3Available: false,
        recommendedCaseId: "blur_mmd_filter",
        pageIds: ["report", "analysis", "threshold"],
        childSetIds: ["260619", "260612"],
    },
    {
        id: "260619",
        label: "260619",
        dataUrl: "/assets/cellytics/260619/analysis-data.json?v=260625-filtered-scale",
        defaultPage: "dashboard",
        backgroundAvailable: true,
        reportAvailable: false,
        i3Available: true,
        recommendedCaseId: "background_blur_mmd_filter",
        showInSidebar: false,
    },
    {
        id: "260612",
        label: "260612",
        dataUrl: "/assets/cellytics/260612/analysis-data.json?v=260625-filtered-scale",
        defaultPage: "dashboard",
        backgroundAvailable: false,
        reportAvailable: false,
        i3Available: true,
        recommendedCaseId: "blur_mmd_filter",
        showInSidebar: false,
    },
];

export function cellyticsAnalysisSet(setId: string) {
    return CELLYTICS_ANALYSIS_SETS.find((row: any) => row.id === setId) || null;
}

export function cellyticsDefaultAnalysisSet() {
    return cellyticsAnalysisSet(CELLYTICS_DEFAULT_ANALYSIS_SET) || CELLYTICS_ANALYSIS_SETS[0];
}

export function cellyticsCurrentAnalysisSetId() {
    const routeSet = (window as any).WizRoute?.segment?.analysisSet;
    const pathSet = location.pathname.split("/").filter((part: string) => !!part)[0];
    const setId = routeSet || pathSet || CELLYTICS_DEFAULT_ANALYSIS_SET;
    return cellyticsAnalysisSet(setId) ? setId : CELLYTICS_DEFAULT_ANALYSIS_SET;
}

export function cellyticsAnalysisDataUrl(setId: string = cellyticsCurrentAnalysisSetId()) {
    return (cellyticsAnalysisSet(setId) || cellyticsDefaultAnalysisSet()).dataUrl;
}

export function cellyticsRecommendedCaseId(setId: string = cellyticsCurrentAnalysisSetId()) {
    return (cellyticsAnalysisSet(setId) || cellyticsDefaultAnalysisSet()).recommendedCaseId;
}

export function cellyticsRoutePath(setId: string, pageId: string) {
    const page = CELLYTICS_ANALYSIS_PAGES.find((row: any) => row.id === pageId) || CELLYTICS_ANALYSIS_PAGES[0];
    return `/${setId}/${page.path}`;
}

export function cellyticsAvailablePages(setId: string) {
    const set = cellyticsAnalysisSet(setId) || cellyticsDefaultAnalysisSet();
    return CELLYTICS_ANALYSIS_PAGES.filter((page: any) => {
        if (Array.isArray(set.pageIds) && set.pageIds.indexOf(page.id) < 0) return false;
        if (page.requiresBackground && !set.backgroundAvailable) return false;
        if (page.requiresReport && !set.reportAvailable) return false;
        if (page.requiresI3 && !set.i3Available) return false;
        if (page.requiresThreshold && !set.thresholdAvailable) return false;
        if (page.requiresRawAnalysis && !set.rawAnalysisAvailable) return false;
        return true;
    });
}

export function cellyticsSidebarRoutes() {
    return CELLYTICS_ANALYSIS_SETS
        .filter((set: any) => set.showInSidebar !== false)
        .map((set: any) => {
            const ownPages = cellyticsAvailablePages(set.id).map((page: any) => ({
                id: page.id,
                label: page.label,
                path: cellyticsRoutePath(set.id, page.id),
                icon: page.icon,
            }));
            const childPages = (set.childSetIds || []).flatMap((childSetId: string) => {
                const childSet = cellyticsAnalysisSet(childSetId);
                if (!childSet) return [];
                return cellyticsAvailablePages(childSetId).map((page: any) => ({
                    id: `${childSetId}-${page.id}`,
                    label: `${childSet.label} ${page.label}`,
                    path: cellyticsRoutePath(childSetId, page.id),
                    icon: page.icon,
                }));
            });
            return {
                date: set.id,
                label: set.label,
                defaultPath: cellyticsRoutePath(set.id, set.defaultPage),
                icon: DATE_ICON,
                activePrefixes: [set.id, ...(set.childSetIds || [])],
                pages: [...ownPages, ...childPages],
            };
        });
}
